/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsGallery = {
  init: function($section) {
    // Add settings from schema to current object
    Shopify.theme.jsGallery = $.extend(this, Shopify.theme.getSectionData($section));

    let gutterSize = 0;
    if(this.show_gutter == true) {
      gutterSize = 20
    }

    if(this.gallery_type == 'masonry') {
      Shopify.theme.applyMasonry('.gallery__item', gutterSize);
    } else if(this.gallery_type == 'horizontal-masonry') {
      Shopify.theme.applyHorizontalMasonry();
    }

    const gallery = document.querySelector('.fertilizers__gallery .gallery-type--classic');
    let flkty = null;

    function initMobileSlider() {
      if (!gallery) return;

      if (window.innerWidth <= 820) {
        if (!flkty) {
          flkty = new Flickity(gallery, {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            prevNextButtons: false,
            pageDots: true,
            draggable: true
          });
        }
      } else {
        if (flkty) {
          flkty.destroy();
          flkty = null;
        }
      }
    }

    initMobileSlider();
    window.addEventListener('resize', initMobileSlider);
  },
  unload: function($section) {

  }
}

/******/ })()
;